import Vue from 'vue';
import moment from "moment";

class DatePlugin {
  install(Vue) {
    Vue.prototype.$date = this;
  }

  simple(date) {
    if (!date) return null

    const [year, month, day] = date.split('-')
    return `${month}/${day}/${year}`
  }

  get(val, format) {
    return moment.utc(val).local().format(format);
  }

  utcToLocal(val) {
    return moment.utc(val).local().format("MM/DD/YYYY hh:mm A");
  }
}
export default DatePlugin;
Vue.use(new DatePlugin());